module.exports = __webpack_public_path__ + "img/cube_1.79d351ec.gif";